// @flow

import type { OperationComponent, QueryProps } from "react-apollo";

import gql from "graphql-tag";
import { graphql } from "react-apollo";

// Retrieve projects
const retrieveProjectsQuery = gql`
  query {
    allProjects {
      id
      name
      template
      archived
      goal
    }
  }
`;

export type ProjectType = {
  id: string,
  name: string,
  template: string,
  archived: boolean,
  goal: number
};

export type retrieveProjectsQueryResult = {
  projectsData: {
    allProjects?: Array<ProjectType>
  } & QueryProps
};

export const withRetrieveProjects: OperationComponent<
  retrieveProjectsQueryResult
> = graphql(retrieveProjectsQuery, {
  name: "projectsData"
});

// ProjectProgress

const projectProgressQuery = gql`
  query($projectId: ID) {
    _allResultsMeta(filter: { task: { project: { id: $projectId } } }) {
      count
    }
  }
`;

export const withProjectProgress = graphql(projectProgressQuery, {
  options: ({ projectId }) => ({
    variables: { projectId }
  }),
  name: "projectProgressData"
});



// WEBPACK FOOTER //
// ./src/data/projects.js